__turbopack_context__.v({
  "clear": "LeaderboardSearch-module-scss-module__fF7QzW__clear",
  "clearIcon": "LeaderboardSearch-module-scss-module__fF7QzW__clearIcon",
  "icon": "LeaderboardSearch-module-scss-module__fF7QzW__icon",
  "input": "LeaderboardSearch-module-scss-module__fF7QzW__input",
  "search": "LeaderboardSearch-module-scss-module__fF7QzW__search",
});
